module.exports = __webpack_public_path__ + "static/img/Jack_Viney_desktop.34eb683.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Viney_desktop.jpg
// module id = fUta
// module chunks = 0